module.exports = __webpack_public_path__ + "static/media/shirtScreenshot.4f39105c.png";